import React from "react";
import { Flag, FileCheck, Download, Filter, ShieldCheck } from "lucide-react";
import Button from "../../components/common/Button";

const GlassCard = ({ children, className = "" }) => (
  <div className={`cht-bg-white/80 cht-backdrop-blur-xl cht-border cht-border-gray-100 cht-shadow-[0_20px_50px_rgba(0,0,0,0.04)] ${className}`}>
    {children}
  </div>
);

const SuperAdminReports = () => (
  <div className="cht-space-y-8 cht-animate-in cht-fade-in cht-duration-700">
    <header className="cht-flex cht-flex-col md:cht-flex-row cht-items-start md:cht-items-center cht-justify-between cht-gap-4">
      <div>
        <h1 className="cht-text-3xl cht-font-black cht-text-[#1e293b] cht-tracking-tight">SuperAdmin Audit & Reports</h1>
        <p className="cht-text-gray-500 cht-font-medium">Generate custom compliance reports, financial summaries, and security audits.</p>
      </div>
      <Button variant="primary" leftIcon={<Download size={18} />} className="cht-rounded-2xl">
        Generate New Master Report
      </Button>
    </header>

    <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6">
      {[
        { title: "Monthly Financial Audit", desc: "Complete breakdown of gross revenue, payout distribution, and platform commission.", date: "May 2026", type: "PDF / CSV" },
        { title: "System Security & Auth Log", desc: "Detailed audit trail of SuperAdmin actions, IP logins, and access token grants.", date: "May 2026", type: "JSON / PDF" },
        { title: "User & Course Moderation Report", desc: "Summary of reported courses, banned user accounts, and resolution statuses.", date: "Apr 2026", type: "PDF" }
      ].map((report, idx) => (
        <GlassCard key={idx} className="cht-p-8 cht-rounded-[32px] cht-space-y-4 cht-flex cht-flex-col cht-justify-between">
          <div className="cht-space-y-3">
            <div className="cht-w-10 cht-h-10 cht-rounded-xl cht-bg-purple-50 cht-text-purple-600 cht-flex cht-items-center cht-justify-center">
              <FileCheck size={20} />
            </div>
            <h3 className="cht-text-lg cht-font-black cht-text-gray-900">{report.title}</h3>
            <p className="cht-text-xs cht-text-gray-500 cht-font-medium">{report.desc}</p>
          </div>
          <div className="cht-pt-4 cht-flex cht-items-center cht-justify-between cht-border-t cht-border-gray-50">
            <span className="cht-text-[10px] cht-font-bold cht-text-gray-400">{report.date} • {report.type}</span>
            <Button variant="ghost" className="cht-text-[#3e57da] cht-text-xs cht-font-bold">Download</Button>
          </div>
        </GlassCard>
      ))}
    </div>
  </div>
);

export default SuperAdminReports;
